export default {
  Id: "ID",
  Code: "Code",
  Name: "Name",
  Description: "Description",
  Quantity: "Quantity",
  Price: "Price",
  Status: "Status",
  Category: "Category",
  Supplier: "Supplier",
  OrderTotal: "Order Total",
  Unit: "Unit",
  Image: "Image",
  OrderId: "Order ID",
  Product: "Product",
  Order: "Order",
  OrderProcessing: "Processing",
  OrderShipped: "Shipped",
  OrderDelivered: "Delivered",
  OrderCancelled: "Cancelled",
  Customer: "Customer",
  Contact: "Contact",
  Country: "Country",
  City: "City",
  Address: "Address",
  PostalCode: "Postal Code",
  Phone: "Phone",
  ShipPhone: "Shipping Phone",
  ShipAddress: "Shipping Address",
  InvoiceAddress: "Invoice Address",
  SameWithShippingAddress: "Same as Shipping Address",
  Employee: "Employee",
  DateOfBirth: "Date of Birth",
  Avatar: "Avatar",
  Department: "Department",
  Type: "Type",
  Note: "Note",
  CategoryInvalid: "Please select a category",
  SupplierInvalid: "Please select a supplier",
  CodeInvalid: "Please enter a code",
  QuantityInvalid: "Please enter a quantity",
  PriceInvalid: "Please enter a price",
  StatusInvalid: "Please select a status",
  NameInvalid: "Please enter a name",
  PhoneInvalid: "Please enter a phone number",
  ContactInvalid: "Please enter a contact",
  CustomerInvalid: "Please select a customer",
  ShippingPhoneInvalid: "Please enter the shipping phone number",
  OrderIdInvalid: "Please enter the order ID",
  DescriptionInvalid: "Please enter a description",
  UnitInvalid: "Please enter a unit",
  IdInvalid: "Please enter an ID",
  AmountInvalid: "Please enter the total amount",
  EmployeeInvalid: "Please select an employee",
  EmailInvalid: "Please enter an email",
  DateOfBirthInvalid: "Please enter the date of birth",
  GroupInvalid: "Please select a group",
  NoteInvalid: "Please enter a note",
  CategoryNameInvalid: "Please enter the category name",
  CategoryDescriptionInvalid: "Please enter the category description",
  AddressInvalid: "Please enter an address",
  CityInvalid: "Please enter a city",
  CountryInvalid: "Please enter a country",
  PostalCodeInvalid: "Please enter a postal code",
  PhoneNumberInvalid: "Please enter a phone number",
  GroupInvalid: "Please enter a group",
  AddProductSuccess: "Add product successful",
  AddProductFail: "Add product failed",
  WorkPhone: "Work Phone",
  SyncCode: "Sync Code",
  UserName: "Username",
  Password: "Password",
  SupplierName: "Supplier name",
  CategoryName: "Category name",
};
